import React, { useEffect } from "react";

export const ExitPage = () => {
	useEffect(() => {
		window.parent.postMessage("CLOSE HOMEPAGE BUILDER", "*");
	}, []);

	return <></>;
};
